import Seco from '@/components/_templates/seco/Index.vue';
import AgreementCheck from '@/components/_templates/seco/AgreementCheck.vue';

const secoRoutes = [
  {
    path: '/seco',
    name: 'seco',
    component: Seco,
    children: [
      {
        path: 'check/:uuid',
        name: 'seco.check',
        component: AgreementCheck,
      },
    ],
  },
];

export default secoRoutes;
